/* tslint:disable */
/* eslint-disable */
/**
 * AusgabeAutomatConnector
 * Connector für Ausgabeautomat zu ORSY Gateway und BDS Gateway.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrsyItemOnLoan
 */
export interface OrsyItemOnLoan {
    /**
     * 
     * @type {string}
     * @memberof OrsyItemOnLoan
     */
    idProduct: string;
    /**
     * 
     * @type {string}
     * @memberof OrsyItemOnLoan
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof OrsyItemOnLoan
     */
    eventTime: string;
    /**
     * 2 - Takeout/Entnahme
     * 10 - Return/Rückgabe
     * 11 - Inventory/Inventur
     * 12 - Set to empty/Leer setzen
     * 13 - Incoming goods/Wareneingang
     * 14 - Open/Öffnen
     * 20 - Takeout from rental box/Entnahme Verleihbox
     * 21 - Return to rental box/Rückgabe Verleihbox
     * 22 - Storno Buchung
     * 30 - Incoming goods to packstation/Wareneingang Packstation
     * 31 - Takeout from packstation/Entnahme Packstation
     * 40 - Product check/Produktprüfung
     * 41 - Return (check)/Rückgabe (Prüfung)
     * 50 - Order group check
     * 999 - Defekter Artikel (Prüfung durch Magazin) - Interner Sonderstatus, nicht in Boostrack-API enthalten
     * 
     * @type {number}
     * @memberof OrsyItemOnLoan
     */
    reason: number;
    /**
     * 
     * @type {string}
     * @memberof OrsyItemOnLoan
     */
    idEmployee: string;
    /**
     * 
     * @type {string}
     * @memberof OrsyItemOnLoan
     */
    employeeName: string;
}

/**
 * Check if a given object implements the OrsyItemOnLoan interface.
 */
export function instanceOfOrsyItemOnLoan(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "idProduct" in value;
    isInstance = isInstance && "productName" in value;
    isInstance = isInstance && "eventTime" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "idEmployee" in value;
    isInstance = isInstance && "employeeName" in value;

    return isInstance;
}

export function OrsyItemOnLoanFromJSON(json: any): OrsyItemOnLoan {
    return OrsyItemOnLoanFromJSONTyped(json, false);
}

export function OrsyItemOnLoanFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrsyItemOnLoan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idProduct': json['idProduct'],
        'productName': json['productName'],
        'eventTime': json['eventTime'],
        'reason': json['reason'],
        'idEmployee': json['idEmployee'],
        'employeeName': json['employeeName'],
    };
}

export function OrsyItemOnLoanToJSON(value?: OrsyItemOnLoan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idProduct': value.idProduct,
        'productName': value.productName,
        'eventTime': value.eventTime,
        'reason': value.reason,
        'idEmployee': value.idEmployee,
        'employeeName': value.employeeName,
    };
}

